import type { IconData } from '@stacksjs/iconify-core'

export const minus: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M72 240h368v32H72z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default minus
